var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.333 13.3337H2.66634C1.92996 13.3337 1.33301 12.7367 1.33301 12.0003V3.94233C1.36408 3.22869 1.95203 2.66632 2.66634 2.66699H13.333C14.0694 2.66699 14.6663 3.26395 14.6663 4.00033V12.0003C14.6663 12.7367 14.0694 13.3337 13.333 13.3337ZM2.66634 5.24566V12.0003H13.333V5.24566L7.99967 8.80033L2.66634 5.24566ZM3.19967 4.00033L7.99967 7.20033L12.7997 4.00033H3.19967Z",
    fill: "#BABABA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.30728d215f645699c95f5fc8a2d268ed.svg";
export { ForwardRef as ReactComponent };